import { Component, OnInit, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs/Observable';

import { Testata } from '../../../models/Testata';
import { BookService } from './../../../services/book.service';

@Component({
  selector: 'app-testata-combo-selector',
  templateUrl: './testata-combo-selector.component.html',
  styleUrls: ['./testata-combo-selector.component.css'],
  providers: [
    BookService,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TestataComboSelectorComponent),
      multi: true
    }
  ]
})
export class TestataComboSelectorComponent implements OnInit {
  items: Observable<any>;
  selected: Testata;
  loading: boolean;

  @Input() placeholder: string;
  @Input() required: boolean = false;
  @Output() notify: EventEmitter<Testata> = new EventEmitter<Testata>();

  constructor(private bookService: BookService) { }

  onChange(e: Testata) {
    this.notify.emit(e);
    this.propagateChange(e);
  }

  set _count(c: number) {
  }

  ngOnInit() {
    this.loading = true;
    this.items = this.bookService.readTestate()
      .map(result => {
        this.loading = false;
        if (result.success) {
          return result.items;
        }
      })
  }

  compareWithFn(o1: Testata, o2: Testata) {
    return o1 && o2 ? o1.codice == o2.codice : false;
  }

  private propagateChange = (_: any) => { };

  public writeValue(obj: Testata) {
    this.items.subscribe(a => {
      if (a) {
        if (obj) {
          this.selected = a.find(p => p.codice == obj.codice);
        }
        this.propagateChange(this.selected);
      }
    })

  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched() { }
}



// WEBPACK FOOTER //
// ./src/app/components/recensione/testata-combo-selector/testata-combo-selector.component.ts